import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=c5e24782"
import script from "./Accounts.vue?vue&type=script&lang=js"
export * from "./Accounts.vue?vue&type=script&lang=js"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=c5e24782&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports